// extracted by mini-css-extract-plugin
export default {"app":"app_app__7GFQA","main":"app_main__7mw5y","section_pod":"app_section_pod__R5hEZ"};